<template>
  <div style="margin-top: 60px">
    <div class="head-class" ref="ctn_head">
      <div class="left">
        <div class="d-flex">
          <div class="btn-white-oval">
            <img src="/img/class/prakerja.png" width="80px" />
          </div>
          <div class="btn-white-oval align-items-center">Webinar</div>
        </div>
        <p class="text-banner">{{ classDetail.name }}</p>
        <div class="description-class">
          <div>
            <BarIc />
            <span>{{ classDetail.level }}</span>
          </div>
          <div>
            <ScreenIc />
            <span>{{ classDetail.method | toMethode }}</span>
          </div>
        </div>
        <v-btn depressed color="#FFDE59" @click="goToCheckoutPage" class="button-daftar mt-10">
          <span class="text-capitalize font-weight-bold blue-text">
            {{ $t('prakerjaDetail.headSection.button') }}
          </span>
        </v-btn>
      </div>
      <img :src="classDetail.image_url" class="img-banner" />
    </div>

    <div class="box-radius">
      <div v-for="(menu, idx) in menuPublicClass" :key="idx" class="menu-detail" @click="clickActiveMenu(menu.layout, menu.position)">
        <span style="font-family: 'Poppins'">{{ $t(`prakerjaDetail.menuPublicClass[${idx}].name`) }}</span>
        <div :class="{ linesmall: layout === menu.layout }"></div>
      </div>

      <v-btn depressed color="#162CA2" @click="goToCheckoutPage" class="btn-radiuss">
        <span class="text-capitalize font-weight-bold white--text">
          {{ $t('prakerjaDetail.menuSection.button') }}
        </span>
      </v-btn>
    </div>

    <div class="container-parent" style="margin-top: -310px" ref="info_kelas">
      <div class="container-detail">
        <span class="addional">{{ $t('prakerjaDetail.infoKelasSection.title') }}</span>
        <h5 class="title-2">{{ $t('prakerjaDetail.infoKelasSection.descriptionProgram') }}</h5>
        <p class="desc">{{ classDetail.description }}</p>
      </div>
      <div class="container-detail" style="margin-top: 50px;">
        <h5 class="title-2">{{ $t('prakerjaDetail.infoKelasSection.scheduleTitle') }}</h5>
        <div class="timeline mt-5" v-for="(item, idx) in classDetail.schedules" :key="idx">
          <div class="timeline-box">
            <div class="ctn">
              <DateIc2 />
              <span class="font-poppins">{{ formatDate(item.start_date) }} - {{ formatDate(item.end_date) }}</span>
            </div>
            <span class="dot"></span>
            <div class="ctn">{{ item.hours }} WIB</div>
          </div>
          <div>
            <span style="color: #01A368" class="font-poppins">
              {{ $t('prakerjaDetail.infoKelasSection.availableLabel') }}
            </span>
          </div>
        </div>
        <EmptyData v-if="!classDetail.schedules || !classDetail.schedules.length"
          :message="$t('prakerjaDetail.infoKelasSection.emptyMessage')" />
      </div>
      <div class="container-detail">
        <div class="box-steps" style="border-radius: 20px; border: 1px #d3d6e1 solid; margin-top: 50px;">
          <div class="box-steps-ctn py-4" style="display: flex;" @click="toggleDetailClass">
            <h2>{{ $t('prakerjaDetail.detailKelasSection.title') }}</h2>
            <ArrowIc :down="!isDetailClass" />
          </div>
          <div class="box-steps-ctn border-top pa-5" v-if="isDetailClass">
            <p v-html="classDetail.learning_objective"></p>
            <h3 class="my-3">{{ $t('prakerjaDetail.detailKelasSection.targetAudience') }}</h3>
            <ul>
              <li v-for="(item, idx) in classDetail.target_audience" :key="idx" class="font-poppins">{{ item.level }}</li>
            </ul>
            <h3 class="my-3">{{ $t('prakerjaDetail.detailKelasSection.learningMethod') }}</h3>
            <p v-html="classDetail.learning_method"></p>
            <h3 class="my-3">{{ $t('prakerjaDetail.detailKelasSection.evaluationTools') }}</h3>
            <ul>
              <li v-for="(item, idx) in $t('prakerjaDetail.evaluasi')" :key="idx" class="font-poppins">{{ item }}</li>
            </ul>
            <h3 class="my-3">{{ $t('prakerjaDetail.detailKelasSection.termsAndConditions') }}</h3>
            <ul>
              <li v-for="(item, idx) in classDetail.requirements" :key="idx" class="font-poppins">{{ item.name }}</li>
            </ul>
            <div class="btn-hide" @click="toggleDetailClass">
              <arrow-ic />
              <span>{{ $t('prakerjaDetail.detailKelasSection.hideButton') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-container" style="margin-bottom: 50px; background: #f1f6ff" ref="materi_silabus">
      <div class="container-detail" style="margin-top: 45px; padding: 60px 0px">
        <span class="font-poppins">{{ $t('prakerjaDetail.materiPembelajaranSection.title') }}</span>
        <h5 class="title-2">{{ $t('prakerjaDetail.materiPembelajaranSection.subtitle') }}</h5>
        <div v-for="(item, idx) in classDetail.syllabuses" :key="idx" class="box-steps">
          <div class="box-steps-ctn pb-3" style="display: flex;" @click="toggleSyllabus(idx)">
            <div>
              <span class="font-poppins">{{ $t('prakerjaDetail.materiPembelajaranSection.sessionPrefix') }} {{ idx + 1 }}</span>
              <h3 v-for="(item2, idx2) in item.name" :key="idx2">{{ item2 }}</h3>
            </div>
            <ArrowIc :down="!item.show" />
          </div>
          <div class="box-steps-ctn border-top pa-5" v-if="item.show">
            <div class="list-art" v-if="idx === 0">
              <img src="/img/icons/file.png" alt="File">
              <div class="info-ars">
                <p>{{ $t('prakerjaDetail.materiPembelajaranSection.preTest') }}</p>
                <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.initialExam') }}</p>
              </div>
            </div>
            <div class="list-art">
              <img src="/img/icons/easel.png" alt="File">
              <div class="info-ars">
                <p>{{ $t('prakerjaDetail.materiPembelajaranSection.liveSession') }} : {{ item.name[0] }}</p>
                <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.liveShareDeck') }}</p>
              </div>
            </div>
            <div class="list-art">
              <img src="/img/icons/file.png" alt="File">
              <div class="info-ars">
                <p>{{ $t('prakerjaDetail.materiPembelajaranSection.formativeTest') }}</p>
                <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.quiz') }} {{ idx + 1 }}</p>
              </div>
            </div>
            <div class="list-art" v-if="idx < 4">
              <img src="/img/icons/file.png" alt="File">
              <div class="info-ars">
                <p>{{ $t('prakerjaDetail.materiPembelajaranSection.individualAssignment') }} {{ idx + 1 }}</p>
                <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.individualAssignment') }}</p>
              </div>
            </div>
            <div class="list-art" v-if="idx >= classDetail.syllabuses.length - 1">
              <img src="/img/icons/file.png" alt="File">
              <div class="info-ars">
                <p>{{ $t('prakerjaDetail.materiPembelajaranSection.postTest') }}</p>
                <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.finalExam') }}</p>
              </div>
            </div>
            <div class="list-art" v-if="idx >= classDetail.syllabuses.length - 1">
              <img src="/img/icons/file.png" alt="File">
              <div class="info-ars">
                <p>{{ $t('prakerjaDetail.materiPembelajaranSection.unjukKeterampilan') }}</p>
                <p style="color: #7B7E8C">{{ $t('prakerjaDetail.materiPembelajaranSection.individualAssignment') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-parent" style="padding: 20px 0px" ref="benefit">
      <div class="container-detail">
        <h5 class="title-2">{{ $t('prakerjaDetail.benefitSection.title') }}</h5>
        <BenefitPrakerja style="margin: 50px 0" />
      </div>
    </div>

    <div class="container-parent" style="margin-bottom: 70px;" ref="instuktur">
      <div class="container-detail">
        <span class="font-poppins">{{ $t('prakerjaDetail.instrukturSection.title') }}</span>
        <h5 class="title-2">{{ $t('prakerjaDetail.instrukturSection.subtitle') }}</h5>
        <div class="narasumber">
          <div>
            <img :src="$utils.loadImage(instructor.image_url)" alt="Profile" class="narasumber-img" />
          </div>
          <div>
            <div>
              <h2>{{ instructor.name }}</h2>
              <span class="sub-title-narasumber">{{ instructor.position }} {{ instructor.company ? `/${instructor.company}` : "" }}</span>
            </div>
            <p class="description-2">{{ instructor.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import goTo from "vuetify/lib/services/goto";
import BenefitPrakerja from "@/components/prakerja/BenefitPrakerja";
import BarIc from "@/assets/icons/BarIc.vue";
import ScreenIc from "@/assets/icons/ScreenIc.vue";
import DateIc2 from "@/assets/icons/DateIc2.vue";
import EmptyData from "../../others/EmptyData.vue";
import ArrowIc from "@/assets/icons/Arrow.vue";
import moment from "moment";

export default {
  components: {
    BenefitPrakerja,
    BarIc,
    ScreenIc,
    DateIc2,
    ArrowIc,
    EmptyData
  },
  data() {
    return {
      classDetail: {
        requirements: [],
      },
      instructor: {},
      isDetailClass: true,
      layout: "info-kelas",
    };
  },
  computed: {
    menuPublicClass() {
      return this.$t('prakerjaDetail.menuPublicClass').map((item, idx) => ({
        name: item.name,
        id: idx + 1,
        position: 0,
        layout: item.layout
      }));
    }
  },
  watch: {
    "$i18n.locale"() {
      this.getDetailClass();
    },
  },
  methods: {
    clickActiveMenu(layout, position) {
      this.layout = layout;
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Menu Click - ${layout} - Prakerja Detail Page`,
        value: 1,
      });
      goTo(Number(position + 10));
    },
    goToCheckoutPage() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Checkout - ${this.classDetail.name} - Prakerja Detail Page`,
        value: 1,
      });
      var classType = "PUBLIC_CLASS";
      if (this.$route.query.tipe_kelas == "prakerja") {
        classType = "PRAKERJA_CLASS";
      } else if (this.$route.query.tipe_kelas == "public-bootcamp") {
        classType = "Kelas Bootcamp";
      }

      const req = JSON.stringify({
        class_id: this.classDetail.class_id,
        class_name: this.classDetail.name,
        price: this.classDetail.price,
        level: this.classDetail.level,
        session: this.classDetail.session_total,
        hour: this.classDetail.hours,
        image_url: this.classDetail.small_image_url,
        class_type: classType,
        days: this.classDetail.days,
        methode: this.classDetail.method,
        category_id: this.classDetail.category_id,
      });

      localStorage.clear();
      localStorage.setItem("checkout", req);
      window.location.href = "/checkout";
    },
    goToCustomerService() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Contact Customer Service - Prakerja Detail Page',
        value: 1,
      });
      window.location.href =
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi Kak HiColleagues, saya mau bertanya";
    },
    formatDate(date) {
      return moment(date).format("dddd, DD/MM/YYYY");
    },
    mappingHeightOfElement() {
      let point = this.$refs.ctn_head.clientHeight;
      this.menuPublicClass[0].position = point;
      point += this.$refs.info_kelas.clientHeight;
      this.menuPublicClass[1].position = point;
      point += this.$refs.materi_silabus.clientHeight;
      this.menuPublicClass[2].position = point;
      point += this.$refs.benefit.clientHeight;
      this.menuPublicClass[3].position = point;
    },
    async getDetailClass() {
      try {
        const response = await this.$http.get(`/v1/class-detail/${this.$route.params.slugname}`);
        this.classDetail = {
          ...response.data.data.class_detail,
          syllabuses: response.data.data.class_detail.syllabuses.map(item => ({
            ...item,
            name: item.description.split("<li>").map(item2 => item2.replace("</ul>", "").replace("</li>", "")),
            show: true,
          }))
        };
        this.classDetail.syllabuses = this.classDetail.syllabuses.map(item => {
          item.name.splice(0, 1);
          return {
            ...item,
            name: item.name
          }
        });
        this.instructor = response.data.data.instructor;
        setTimeout(() => {
          this.mappingHeightOfElement();
        }, 1000);
      } catch {
        this.$router.push('/prakerja');
      }
    },
    handleScroll() {
      this.menuPublicClass.forEach((item) => {
        if (item.position <= window.scrollY) {
          this.layout = item.layout;
        }
      });
    },
    toggleDetailClass() {
      this.isDetailClass = !this.isDetailClass;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle Class Details - ${this.isDetailClass ? 'Expand' : 'Collapse'} - Prakerja Detail Page`,
        value: 1,
      });
    },
    toggleSyllabus(idx) {
      this.classDetail.syllabuses[idx].show = !this.classDetail.syllabuses[idx].show;
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Toggle Syllabus - Session ${idx + 1} - Prakerja Detail Page`,
        value: 1,
      });
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.getDetailClass();
    this.$gtag.pageview(this.$route);
  },
  filters: {
    toMethode(value) {
      if (!value) return '';
      if (value.toLowerCase() === 'online') {
        return 'Daring (via Zoom)';
      } else if (value.toLowerCase() === 'offline') {
        return 'Luring';
      } else {
        return value;
      }
    },
  },
};
</script>

<style src="./detailClass.css" scoped></style>